import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { brandUrl } from '../../../util/url';

import './ProductModelHero.css';

/**
 * 브랜드 모델 페이지 헤더.
 * @param brandName 브랜드명
 * @param model { name, name_kr } 카탈로그 모델
 * @returns {JSX.Element}
 * @constructor
 */
export default function ProductModelHero({ brandName, model }) {
    return (
        <header className="ProductModelHero">
            <div className="ProductModelHero-inner">
                <nav className="ProductModelHero-breadcrumb" aria-label="Breadcrumb">
                    <Link to="/">홈</Link>
                    <span className="ProductModelHero-breadcrumb-sep" aria-hidden="true">›</span>
                    <Link to={brandUrl(brandName)}>{brandName}</Link>
                </nav>
                <div className="ProductModelHero-titles">
                    <h1 className="ProductModelHero-name">{model.name}</h1>
                    {model.name_kr && (
                        <span className="ProductModelHero-name-kr">{model.name_kr}</span>
                    )}
                </div>
            </div>
        </header>
    );
}

ProductModelHero.propTypes = {
    brandName: PropTypes.string.isRequired,
    model: PropTypes.shape({
        name: PropTypes.string.isRequired,
        name_kr: PropTypes.string,
    }).isRequired,
};
